module.exports = "<div id=\"category-filter\" class=\"aside__filters v1\">\r\n  <div class=\"widget__products widget-aside\">\r\n    <h3 class=\"widget__title bg-gradient\">Líneas de Productos</h6>\r\n    <div class=\"widget__wrapper widget__accordion\">\r\n      <categories-accordion items=\"$ctrl.shCtrl.globalCategoriesMenu[0].hijas\"></categories-accordion>\r\n    </div>\r\n  </div>\r\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/catalog/categories-filter/categories-slider-filter/templates/categories-slider-filter-t1.view.html
 ** module id = 423
 ** module chunks = 0
 **/